export default __webpack_public_path__ + "static/media/safari.013d9f47.svg";